import styles from '../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div className={styles.template_preview_container}>
      <h2>Vault Overview</h2>
      <p>
        Store and organise your{' '}
        <strong>important business documents in a secure, central location</strong>.
      </p>

      <p>
        The Vault is your searchable repository for agreements, certificates, licences, policies,
        and any files you want to keep safe and easy to access. Upload documents once and retrieve
        them across the platform without relying on separate storage tools.
      </p>
      <p>
        <strong>Risk of not using this:&nbsp;</strong>Misplaced contracts or missing records can
        lead to failed audits, compliance breaches or legal claims you can’t defend.
      </p>
      <p>
        <strong>Tip:&nbsp;</strong>Add labels as you upload to make documents easier to find later.
      </p>
    </div>
  );
};

export default Preview;
